import { Link, useLocation } from 'react-router';
import { LayoutDashboard, Users, Building2, Package, TestTube, CheckCircle, FileKey, Settings, Database, Home } from 'lucide-react';

const nav = [
  { label: 'Overview', href: '/ashkeep', icon: LayoutDashboard },
  { label: 'Users', href: '/ashkeep/users', icon: Users },
  { label: 'Organizations', href: '/ashkeep/organizations', icon: Building2 },
  { label: 'Tools', href: '/ashkeep/tools', icon: Package },
  { label: 'Testing', href: '/ashkeep/testing', icon: TestTube },
  { label: 'Approvals', href: '/ashkeep/approvals', icon: CheckCircle },
  { label: 'Manifests', href: '/ashkeep/manifests', icon: FileKey },
  { label: 'Settings', href: '/ashkeep/settings', icon: Settings },
  { label: 'D1 Explorer', href: '/ashkeep/d1', icon: Database },
];

export default function AshKeepSidebar() {
  const { pathname } = useLocation();

  return (
    <>
      <div className="sidebar-logo">
        <Link to="/" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
          <Home size={16} style={{ color: 'var(--text-tertiary)' }} />
          <span style={{ color: '#921f46', fontWeight: 700 }}>AshKeep</span>
          <span style={{ fontSize: '0.7rem', color: 'var(--text-tertiary)', fontWeight: 400 }}>admin</span>
        </Link>
      </div>
      <nav className="sidebar-nav">
        <div className="sidebar-section">
          <div className="sidebar-section-title">Governance</div>
          {nav.map(({ label, href, icon: Icon }) => (
            <Link key={href} to={href} className={`sidebar-link ${pathname === href || (href !== '/ashkeep' && pathname.startsWith(href + '/')) ? 'active' : ''}`}>
              <Icon /> {label}
            </Link>
          ))}
        </div>
      </nav>
    </>
  );
}
